import React from 'react'
import { Table, FormCheck } from 'react-bootstrap'
import {
  NOTIFICATIONS_TABLE_SORT_BODY,
  NOTIFICATIONS_TABLE_SORT_CREATED,
  NOTIFICATIONS_TABLE_SORT_IMPORTANCE,
  NOTIFICATIONS_TABLE_SORT_READ,
  NOTIFICATIONS_TABLE_SORT_SUBJECT,
  NOTIFICATIONS_TABLE_SORT_TYPE,
} from '../../actions/notifications_table_sort'
import ImportanceIcon from '../../components/notifications/importance-icon'
import { emailTimeDisplay } from '../../utils/formatters'
import { getSortIcon } from '../../utils/sort'

const truncate = (str, len = 128) => (str && str.length > len ? str.substr(0, len - 1) + '...' : str)

const getClassName = ({ state, message }) => {
  if (state === 'pending' || state === 'delivered') {
    let importance = message.message_importance ? `${message.message_importance.name}` : ''
    if (importance === 'warning' || importance === 'critical') {
      return `unread warning`
    }
    return `unread`
  }
  return ''
}

const NotificationsTable = ({ results, handleTableSort, sortOrder, sortField, goTo, selected, handleChange }) => (
  <Table bordered hover>
    <colgroup>
      <col width='30px' />
      <col width='30px' />
      <col width='120px' />
      <col />
      <col />
      <col width='90px' />
      <col width='90px' />
    </colgroup>
    <thead>
      <tr>
        <th className='cursor-pointer td-nowrap' />
        <th className='cursor-pointer td-nowrap' onClick={() => handleTableSort(NOTIFICATIONS_TABLE_SORT_IMPORTANCE)}>
          <div>
            <div style={{ float: 'left' }} />
            {getSortIcon(sortOrder, sortField, NOTIFICATIONS_TABLE_SORT_IMPORTANCE)}
          </div>
        </th>
        <th className='cursor-pointer td-nowrap' onClick={() => handleTableSort(NOTIFICATIONS_TABLE_SORT_TYPE)}>
          <div>
            <div style={{ float: 'left' }}>Type</div>
            {getSortIcon(sortOrder, sortField, NOTIFICATIONS_TABLE_SORT_TYPE)}
          </div>
        </th>
        <th className='cursor-pointer td-nowrap' onClick={() => handleTableSort(NOTIFICATIONS_TABLE_SORT_SUBJECT)}>
          <div>
            <div style={{ float: 'left' }}>Subject</div>
            {getSortIcon(sortOrder, sortField, NOTIFICATIONS_TABLE_SORT_SUBJECT)}
          </div>
        </th>
        <th className='cursor-pointer td-nowrap' onClick={() => handleTableSort(NOTIFICATIONS_TABLE_SORT_BODY)}>
          <div>
            <div style={{ float: 'left' }}>Body</div>
            {getSortIcon(sortOrder, sortField, NOTIFICATIONS_TABLE_SORT_BODY)}
          </div>
        </th>
        <th className='cursor-pointer td-nowrap' onClick={() => handleTableSort(NOTIFICATIONS_TABLE_SORT_CREATED)}>
          <div>
            <div style={{ float: 'left' }}>Created</div>
            {getSortIcon(sortOrder, sortField, NOTIFICATIONS_TABLE_SORT_CREATED)}
          </div>
        </th>
        <th className='cursor-pointer td-nowrap' onClick={() => handleTableSort(NOTIFICATIONS_TABLE_SORT_READ)}>
          <div>
            <div style={{ float: 'left' }}>Read</div>
            {getSortIcon(sortOrder, sortField, NOTIFICATIONS_TABLE_SORT_READ)}
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      {results.results.map((item, index) => (
        <tr key={index} className={getClassName(item)}>
          <td>
            <FormCheck checked={selected.map((i) => i.id).includes(item.id)} onChange={() => handleChange(item)} />
          </td>
          <td>
            <ImportanceIcon status={item.message.message_importance ? item.message.message_importance.name : ''} />
          </td>
          <td>{item.message.message_type ? item.message.message_type.name : ''}</td>
          <td className='ellipsis' style={{ cursor: 'pointer', maxWidth: 150 }} onClick={() => goTo(item)}>
            {item.message.subject}
          </td>
          <td style={{ cursor: 'pointer' }} onClick={() => goTo(item)}>
            {truncate(item.message.body, 100)}
          </td>
          <td>{item.created ? <span className='badge'>{emailTimeDisplay(item.created)}</span> : ''}</td>
          <td>{item.date_read ? <span className='badge'>{emailTimeDisplay(item.date_read)}</span> : ''}</td>
        </tr>
      ))}
    </tbody>
  </Table>
)

export default NotificationsTable
